module.exports = __webpack_public_path__ + "img/Pic_Services-6.ee95f5fb.jpg";